import React from "react";

//kendo component
import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";

//localization
import { useLocalization } from "@progress/kendo-react-intl";

export const IdleTimeOutModal = ({
  showModal,
  handleClose,
  handleLogout,
  remainingTime,
}) => {
  //localization
  const localizationService = useLocalization();

  return (
    showModal && (
      <Dialog
        title={localizationService.toLanguageString("custom.idle")}
        onClose={handleClose}
      >
        <p
          style={{
            margin: "25px",
            textAlign: "center",
          }}
        >
          {localizationService.toLanguageString("custom.timeout")}?
        </p>

        <div className="row">
          <div className="col">
            <Button
              onClick={handleLogout}
              className="mr-2em"
              style={{ width: "230px" }}
              primary={true}
            >
              {localizationService.toLanguageString("custom.logout")}
            </Button>
            <Button onClick={handleClose} style={{ width: "230px" }}>
              {localizationService.toLanguageString("custom.stay")}
            </Button>
          </div>
        </div>
      </Dialog>
    )
  );
};
